// extracted by mini-css-extract-plugin
export default {"addButton":"AnnotationsList_addButton__3ESdV"};